export const ADD_BUSY = '@@profile/ADD_BUSY'
export const REMOVE_BUSY = '@@profile/REMOVE_BUSY'
export const LOGIN = '@@profile/LOGIN'
export const LOGINTOKEN = '@@profile/LOGINTOKEN'
export const LOGOUT = '@@profile/LOGOUT'

export interface ProfileState {
	authenticated: boolean;
	accessToken: string;
}

export interface Login {
	username: string;
	password: string;
}

export interface LoginAction {
	type: typeof LOGIN;
	payload: { authenticated: boolean };
}

export interface LoginTokenAction {
	type: typeof LOGINTOKEN;
	payload: { authenticated: boolean };
}

export interface LogoutAction {
	type: typeof LOGOUT;
}

export type ProfileActionTypes = LoginTokenAction | LoginAction | LogoutAction
